import typografFixText from '../utils/typograf';

type Returned = (
  text?: string,
  params?: Record<string, string | number>,
) => string;

export default function useTypograph(): Returned {
  function t(text = ''): string {
    return typografFixText(text);
  }

  return t;
}
